// extracted by mini-css-extract-plugin
export default {"status-card":"OrderStatus_status-card__mDHXl","btn":"OrderStatus_btn__oZb5q"};